import { Container, Grid } from '@material-ui/core'
import React, { useState, useEffect, useMemo } from 'react'
import { ButtonHLPure, ComboBoxTemplatePure, DialogPdf, DialogSystemGLPure, DialogYesNoHLPure, GridSelectionHLPure, HeaderHLPure, PromotionalFooterPure, SimpleLoading, InstructionsPure, LabelModalPure, ButtonAddHLPure, DropDownBtnHLPure, DialogExtractEntities } from '../../pures'
import './digital-vault-upload.css'
// import { useMediaQuery } from '@material-ui/core'
import PdfReader from '../../pures/adobePfdReader/PdfReader'
import { useTranslation } from 'react-i18next'
import { ChipList, Chip } from '@progress/kendo-react-buttons'
import { TextAreaHLPure, InputHLPure, PanelBarGLPure, Traslates, CheckBoxHLPure, DataPickerHLPure } from '../../pures'
import DocumentPanelBarVariables from '../digital-vault-document/document-panel-bar-variables'
import { TreeViewComponent } from '@syncfusion/ej2-react-navigations'
import { FormatTextUtil } from '../../../utils'
import '../digital-vault-document/digital-vault-document.view.css'

const getSubcategoryPath = (tree, id, path = []) => {
  for (let i = 0; i < tree.length; i++) {
    const element = tree[i]
    if (element.subcategory.id === id) {
      return [...path, element.subcategory.id]
    }
    const nextLevelSearch = getSubcategoryPath(element.items || [], id, [...path, element.subcategory.id])
    if (nextLevelSearch) return nextLevelSearch
  }
}

const traceSubcategoryPath = (tree, path, hierarchicalIndex = '') => {
  if (path.length === 0) return hierarchicalIndex.slice(1)

  let catIndex = tree.findIndex(i => i.subcategory.id === path[0])
  if (catIndex !== -1) {
    return traceSubcategoryPath(tree[catIndex].items || [], path.slice(1), `${hierarchicalIndex}_${catIndex}`)
  } else {
    return []
  }
}


const HeaderColumns = (props) => {
  return (
    <span className={(props.title === props.t('digitalVaultUploadView.grid.title.1') || props.title === props.t('digitalVaultUploadView.modal.entities.grid.title.1')) ? 'grid-header-one' : 'grid-headers'}>{props.title}</span>
  )
}

const CellColumnOne = (props) => {
  const {
    dataItem
  } = props

  return (
    <td className={`digitalVaultUploadView-col1 ${dataItem.selected ? 'selected' : ''}`}>
      <div>
        <p className='grid-cell-titles-margin-left grid-cell-title'>{dataItem.name}</p>
      </div>
    </td>
  )
}


const DigitalVaultUploadView = (props) => {
  const {
    isLoading,
    showLoadingRequesting,
    toggleErrorRequesting,
    showCompletedRequesting,
    toggleLoadingRequesting,
    showErrorRequesting,
    toggleCompletedRequesting,
    messageError,
    fileType,
    companies,
    subcategoryTree,
    allTypeDocuments,
    typeDocuments,
    setTypeDocuments,
    handleFile,
    deleteFile,
    uploadData,
    handleUploadDataChange,

    onCancel,
    onSave,
    invalidFields,
    setInvalidFields,

    documentId,
    handleUpdateDocument,
    urlPdf,
    blobAWS,
    handleWathchExp,

    showUploadBtn,
    showBtnCancel,
    rejectUploadDocument,
    showDialogSendDocToOcr,
    closeModalSendToOcr,
    documentsToOCR,
    handleCheckBoxDoc,
    totalCredits,
    setFileType,

    // Categorias y subcategorias
    handleTreeNodeClick,
    strBtn,
    categoriesData,
    showCategoryWarningModal,
    toggleCategoryWarningModal,
    openSubcategories,
    showCategoryInputDialog,
    setShowCategoryInputDialog,
    categoryNameError,
    setCategoryName,
    categoryName,
    handleCreateCategoryOrSubcategory,
    openCategories,

    // Tags
    onBlurInputTag,
    disableElements,
    handleInputTag,
    inputTag,
    handleDeleteChipTag,
    tags,

    // Dates
    onChangeDatepicker,
    onChangeDatepickerDateEnd,
    dateStart,
    dateEnd,
    formatCeleb,
    formatVen,
    limitDateDue,

    // Checkboxes
    handleChangeCheckConfidential,
    confidential,
    handleChangeCheckNotify,
    notify,

    //Variables
    customVariables,
    setCustomVariables,
    formatVariables,

    // Entidades
    openModalExtractEntities,
    saveExtractedEntities,
    entitiesExtracted,
    showEntitiesSuccessModal,
    messageDialog,
    ENV
  } = props

  const { t, i18n } = useTranslation()
  const [viewCancelDialog, setViewCancelDialog] = useState(false)
  const [showRejectDialog, setShowRejectDialog] = useState(false)
  const [realFileType, setRealFileType] = useState('')


  const pdfAWS = useMemo(() => <PdfReader useFullHeight className='pdfReader' url={urlPdf} awsURL showDownloadPDF={false} />, [urlPdf])
  const formatTextUtil = useMemo(() => new FormatTextUtil(), [])

  useEffect(() => {
    setRealFileType(fileType)
  }, [fileType])


  const onDataChange = (event, field) => {
    let value

    if (field === 'typeDocument') {
      value = event.value
      if (value && value.id === undefined) {
        value = {
          ...value,
          id: -1,
        }
      }
    } else if (field === 'pathBreadcrumb') {
      const path = getSubcategoryPath(subcategoryTree, event.item.subcategory.id)
      value = path
    } else if (field === 'categoryId') {
      value = parseInt(event.target.value)
    } else {
      value = event.target.value
    }

    setInvalidFields(prev => prev.filter(i => i !== field))
    handleUploadDataChange(field, value)
  }

  useEffect(() => {
    if (subcategoryTree.length && uploadData.pathBreadcrumb && uploadData.pathBreadcrumb.length) {
      const hierarchicalIndex = traceSubcategoryPath(subcategoryTree, uploadData.pathBreadcrumb)
      setSelected([hierarchicalIndex])
      setExpand(prev => ({
        ids: [...new Set([...(prev?.ids || []), ...uploadData.pathBreadcrumb])],
        idField: 'subcategory.id'
      }))
    } else {
      setSelected([''])
      setExpand({ ids: [], idField: 'subcategory.id' })
    }
  }, [subcategoryTree, uploadData.pathBreadcrumb])


  const [, setSelected] = useState([''])
  const [, setExpand] = useState({
    ids: [],
    idField: 'subcategory.id'
  })


  const [fileShown, setFileShown] = useState({})
  const pdf = useMemo(() => <PdfReader className='pdfReader' file={fileShown.file ? fileShown.fileBase64 : ''} isFile src={`data:application/pdf;base64,${fileShown.file ? fileShown.fileBase64 : ''}`}  ></PdfReader>, [fileShown])

  useEffect(() => {
    let files = uploadData.uploadedFiles
    if (files.length === 0) setFileShown({})
    else if (files.length === 1) setFileShown(files[0])
    else if (files.findIndex(f => f.name === fileShown.name && f.fileBase64 === fileShown.fileBase64) === -1) setFileShown(files[0])
  }, [uploadData.uploadedFiles, fileShown.name, fileShown.fileBase64])

  const [fileSelected, setFileSelected] = useState({})
  useEffect(() => {
    if (!fileSelected || !fileSelected.fileBase64) return
    setFileShown(fileSelected)
  }, [fileSelected])

  useEffect(() => {
    if (!uploadData || !uploadData.infoType) return
    const infoTypeString = (uploadData.infoType === 1) ? ENV.REACT_APP_DIGITAL_VAULT_DOCUMENT : ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE
    const typeDocumentsFiltered = allTypeDocuments.filter(td => { return td.infoType === infoTypeString })
    setTypeDocuments(typeDocumentsFiltered)
  }, [uploadData, uploadData.infoType, ENV.REACT_APP_DIGITAL_VAULT_DOCUMENT, ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE, allTypeDocuments, setTypeDocuments])


  let skip = 0
  if (fileShown.file) {
    const i = uploadData.uploadedFiles.findIndex(f => f.name === fileShown.name && f.fileBase64 === fileShown.fileBase64)
    if (i !== -1) skip = Math.floor(i / 5) * 5
  }

  const uploadDocumentFromDialog = (ocrSelected) => {
    closeModalSendToOcr()
  }

  let AllHeadersColumns = (props) => <HeaderColumns {...props} t={t} />

  let widthColumnOne = '150px'
  let widthColumnFive = '50px'
  let widthColumnTwo = 'auto'

  const aiScheduledText = t('digitalVaultUpload.view.extracted.entities')
  const noAiText = t('digitalVaultUpload.view.not.extracted.entities')

  const isSpanish = (i18n?.language || 'es').toLowerCase().startsWith('es')
  const safeT = (key, def) => {
    const v = t(key)
    return v && v !== key ? v : def
  }
  const nounFile = safeT('digitalVaultUpload.noun.file', isSpanish ? 'expediente' : 'file')
  const nounDoc = safeT('digitalVaultUpload.noun.document', isSpanish ? 'documento' : 'document')
  const dynamicNoun = uploadData?.infoType === 2 ? nounFile : nounDoc
  const subcategoryRequiredMsg = t('digitalVaultUpload.error.select.subcategory.withNoun', {
    noun: dynamicNoun,
    defaultValue: isSpanish
      ? `Es necesario seleccionar una subcategoría para clasificar el ${dynamicNoun}.`
      : `You need to select a subcategory to classify the ${dynamicNoun}.`
  })

  //TODO: funcion para arrastrar y soltar archivos + mas modal de validacion de nuevo documento
  const [showAlert, setShowAlert] = useState(false)
  const [messageAlert, setMessageAlert] = useState('')

  const showAlertDialog = (message) => {
    setMessageAlert(message)
    setShowAlert(true)
  }

  const closeAlertDialog = () => {
    setShowAlert(false)
  }

  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i]
  }

  const handleDrop = async (e) => {
    e.preventDefault()

    const files = e.dataTransfer.files
    const MAX_FILE_SIZE_MB = 80
    const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024

    if (uploadData.infoType == 1) {
      if (files.length > 1) {
        showAlertDialog(t('digitalVaultUploadView.description.rule'))
        return
      }

      if (files[0].size > MAX_FILE_SIZE_BYTES) {
        const formattedSize = formatBytes(files[0].size)
        const limitFormatted = formatBytes(MAX_FILE_SIZE_BYTES)
        showAlertDialog(
          `${t('loadFields.max.file.size')} '${files[0].name}' ${t('loadFields.exceed.max.file.size')} ${formattedSize} ${t('loadFields.exceed.max.file.size.limit')} ${limitFormatted}.`
        )
        return
      }

      await handleFile({ target: { files } })
    }

    if (uploadData.infoType == 2) {
      for (let i = 0; i < files.length; i++) {
        if (files[i].size > MAX_FILE_SIZE_BYTES) {
          const formattedSize = formatBytes(files[i].size)
          const limitFormatted = formatBytes(MAX_FILE_SIZE_BYTES)
          showAlertDialog(
            `${t('loadFields.max.file.size')} '${files[i].name}' ${t('loadFields.exceed.max.file.size')} ${formattedSize} ${t('loadFields.exceed.max.file.size.limit')} ${limitFormatted}.`
          )
          return
        }
      }

      await handleFile({ target: { files } })
    }
  }

  const handleDragOver = (e) => {
    e.preventDefault()
  }

  let treeRef = null

  function getCategoryDialogText(key) {
    const isCategory = strBtn === t('fileManager.toolbar.newCategory')
    const map = {
      saveBtn: isCategory
        ? t('fileManager.createCategory.dialog.saveBtn')
        : t('fileManager.createSubcategory.dialog.saveBtn'),
      cancelBtn: t('fileManager.createCategory.dialog.cancelBtn'),
      header: isCategory
        ? t('fileManager.createCategory.dialog.header')
        : t('fileManager.createSubcategory.dialog.header'),
      errorInputText: isCategory
        ? t('fileManager.createCategory.dialog.errorInputText')
        : t('fileManager.createSubcategory.dialog.errorInputText'),
      categoryInput: isCategory
        ? t('fileManager.createCategory.dialog.categoryInput')
        : t('fileManager.createSubcategory.dialog.categoryInput'),
      confirmHeader: isCategory
        ? t('fileManager.createCategory.dialog.confirmHeader')
        : t('fileManager.createSubcategory.dialog.confirmHeader'),
      confirmDescription: isCategory
        ? t('fileManager.createCategory.dialog.confirmDescription')
        : t('fileManager.createSubcategory.dialog.confirmDescription'),
    }
    return map[key]
  }

  const onEnterTag = (e) => {
    if (e.key === 'Enter' || e.key === 'NumpadEnter') {
      e.preventDefault()
      if (inputTag.trim() !== '') {
        onBlurInputTag()
      }
    }
  }

  const uploadFilesIcon = `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_UPLOAD_FILES_ICON}`

  const typeDocumentIdRef = uploadData && uploadData.typeDocument ? uploadData.typeDocument.id : 0
  const documentDataForVariables = useMemo(() => {
    const docId = documentId || null
    return { id: docId, typeDocumentId: typeDocumentIdRef || 0 }
  }, [typeDocumentIdRef, documentId])

  const variablesList = useMemo(() => {
    return (customVariables || []).filter(v => !v.deleted).map((v, idx) => {
      return ({
        id: v.id ?? v._tmpId ?? idx + 1,
        variableId: v.id ?? v._tmpId ?? idx + 1,
        name: v.variableName || v.name,
        variableName: v.variableName || v.name,
        typeData: v.typeData || 'text',
        value: v.valueVariable ?? v.value,
        valueVariable: v.valueVariable ?? v.value,
        formatVariableKey: v.formatVariableKey || v.format || '',
        convertedValue: (() => {
          const type = (v.typeData || '').toLowerCase()
          const formatKey = v.formatVariableKey || v.format || ''
          const raw = v.valueVariable ?? v.value

          if (type === 'boolean') {
            if (v.values) return v.values?.checked ? v.values?.true : v.values?.false
            if (raw && typeof raw === 'object') {
              return raw?.checked ? raw?.true : raw?.false
            }
            return ''
          }

          if (type === 'date') {
            let iso = ''
            if (raw instanceof Date) {
              iso = raw.toISOString()
            } else if (typeof raw === 'string') {
              const d = new Date(raw)
              iso = isNaN(d.getTime()) ? '' : d.toISOString()
              if (!iso && /\d{4}-\d{2}-\d{2}/.test(raw)) iso = raw
            }
            if (!iso) return ''
            return formatKey ? formatTextUtil.formatVariableValue(iso, formatKey) : iso.slice(0, 10)
          }

          if (formatKey && (raw ?? '') !== '') {
            try {
              return formatTextUtil.formatVariableValue(raw, formatKey)
            } catch (e) {
              return raw
            }
          }
          return raw ?? ''
        })()
      })
    })
  }, [customVariables, formatTextUtil])

  const createOrUpdateVariableAdapter = async (variable) => {
    setCustomVariables(prev => {
      const next = [...prev]
      const id = variable.id || variable.variableId
      const name = variable.variableName || variable.name
      if (id || name) {
        const i = next.findIndex(v =>
          (id != null && (v.id === id || v._tmpId === id)) ||
          (name != null && String(v.variableName || v.name || '').trim().toLowerCase() === String(name).trim().toLowerCase())
        )
        if (i !== -1) {
          next[i] = {
            ...next[i],
            variableName: variable.variableName,
            typeData: variable.typeData,
            valueVariable: variable.valueVariable,
            formatVariableKey: variable.formatVariableKey || next[i].formatVariableKey || ''
          }
          return next
        }
      }
      next.push({
        _tmpId: Date.now(),
        variableName: variable.variableName,
        typeData: variable.typeData,
        valueVariable: variable.valueVariable,
        formatVariableKey: variable.formatVariableKey || ''
      })
      return next
    })
    return true
  }

  const deleteVariableAdapter = async (variableOrId) => {
    const id = typeof variableOrId === 'number'
      ? variableOrId
      : (variableOrId?.id || variableOrId?.variableId)
    const name = typeof variableOrId === 'object' ? (variableOrId.name || variableOrId.variableName) : null

    setCustomVariables(prev => {
      let next = prev
      if (id != null) {
        next = next.filter(v => v.id !== id && v.variableId !== id && v._tmpId !== id)
      }
      if (name) {
        const norm = String(name).trim().toLowerCase()
        next = next.filter(v => {
          const n = String(v.variableName || v.name || '').trim().toLowerCase()
          return n !== norm
        })
      }
      return next
    })
    return true
  }

  const clearVariableValueAdapter = async (variableOrId) => {
    const id = typeof variableOrId === 'number'
      ? variableOrId
      : (variableOrId?.id || variableOrId?.variableId)
    const name = typeof variableOrId === 'object' ? (variableOrId.name || variableOrId.variableName) : null

    setCustomVariables(prev => prev.map(v => {
      const matchesId = id != null && (v.id === id || v.variableId === id || v._tmpId === id)
      const matchesName = name
        ? String(v.variableName || v.name || '').trim().toLowerCase() === String(name).trim().toLowerCase()
        : false
      if (matchesId || matchesName) {
        if ((v.typeData || '').toLowerCase() === 'boolean') {
          return { ...v, valueVariable: undefined, value: undefined, values: { checked: false } }
        }
        return { ...v, valueVariable: undefined, value: undefined }
      }
      return v
    }))
    return true
  }

  return (
    <>
      <div className='standard-wrapper'>
        {
          isLoading
            ? <SimpleLoading />
            : <>
              <Container>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <HeaderHLPure title={`${uploadData.infoType === 1 ? t('digitalVaultUploadView.title.document') : t('digitalVaultUploadView.title.exp')}`} />
                  </Grid>

                  <Grid item xs={12} md={6} spacing={4}>
                    {/* DATOS DE DOCUMENTO */}
                    <Grid>
                      <PanelBarGLPure
                        expandedPanel={true}
                        titlePanel={`${uploadData.infoType === 1 ? (t('digitalVaultUploadView.modal.document.data.title')) : (t('digitalVaultUploadView.modal.file.data.title'))}`}
                        id='documentPanelBarVariables'
                      >
                        <span style={{ fontFamily: "QuickSand", fontWeight: 600, fontSize: 14, color: "#427FBA", opacity: 1 }}>{t('digitalVaultUploadView.storage.type')}</span>
                        <div className="documentPanelBarBasicData-checkBox-group">
                          <label className="checkbox-item">
                            <CheckBoxHLPure
                              checkedState={uploadData.infoType === 1}
                              onChangeHandler={() => onDataChange({ target: { value: 1 } }, 'infoType')}
                              disabled={!!documentId}
                            />
                            <span>{t('digitalVaultUploadView.data.document')}</span>
                          </label>

                          <label className="checkbox-item">
                            <CheckBoxHLPure
                              checkedState={uploadData.infoType === 2}
                              onChangeHandler={() => onDataChange({ target: { value: 2 } }, 'infoType')}
                              disabled={!!documentId}
                            />
                            <span>{t('digitalVaultUploadView.data.exp')}</span>
                          </label>
                          <InputHLPure
                            labelInput={uploadData.infoType == 1 ? t('digitalVaultUploadView.document.name') : t('digitalVaultUploadView.document.exp')}
                            inputActive
                            valueInput={uploadData.name}
                            handleChangeInput={(e) => onDataChange(e, 'name')}
                            typeInput={'text'}
                            characterLimit={128}
                            errorInput={invalidFields.includes('name')}
                            errorInputText={t('digitalVaultUploadView.errors.name')}
                            required
                          />

                          {
                            uploadData.infoType == 2 &&
                            <Grid item xs={12} className='digitalVaultUploadView-grid'>
                              <GridSelectionHLPure
                                skip={skip}
                                take={5}
                                pageable
                                dataGrid={uploadData.uploadedFiles.map(f => f.name == fileShown.name && f.fileBase64 == fileShown.fileBase64 ? { ...f, selected: true } : { ...f })}
                                noRecordsMessage={t('digitalVaultUploadView.errors.no.records')}

                                titleRow1={t('digitalVaultUploadView.grid.title.1')}
                                cellColumnOne={CellColumnOne}
                                headerColumnOne={AllHeadersColumns}
                                widthColumnOne={widthColumnOne}
                                minResizableWidth1={'auto'}

                                columnFive
                                columnFiveStyleClass={'digitalVaultUploadView-cellActions'}
                                titleRow5={t('digitalVaultUploadView.grid.title.5')}
                                iconOneActive
                                labelOneActions={t('digitalVaultUploadView.grid.btns.view.document')}
                                activeDialog1
                                btnOpenDialog1={(!documentId) ? (dataItem) => {
                                  setFileType(dataItem.fileType)
                                  setFileShown(dataItem)
                                } :
                                  (dataItem) => handleWathchExp(dataItem)
                                }
                                iconTrashActive={(!documentId) ? true : false}
                                labelTrashActions={t('digitalVaultUploadView.grid.btns.delete')}
                                activeDialogTrash={(!documentId) ? true : false}
                                btnOpenDialogTrash={(dataItem) => deleteFile(dataItem)}
                                tooltipTrashIcon={t('button.delete')}
                                widthColumnFive={widthColumnFive}
                                minResizableWidth5={widthColumnFive}

                                onSelectedItem={setFileSelected}
                                setNameComponentUser={() => { }}
                                setShowDetails={() => { }}
                              />
                            </Grid>
                          }

                          <div className='digitalVaultFollowUpDocument-followUpDocumentBasicData' style={{ width: '100%' }}>
                            <div className='digitalVaultFollowUpDocument-followUpDocumentBasicData-description'>
                              <TextAreaHLPure
                                valueTextData={uploadData.description}
                                labelTextArea={t('digitalVaultFollowUpDocument.description')}
                                characterLimit={1000}
                                handleChangeTextArea={(e) => onDataChange(e, 'description')}
                              />
                            </div>
                            <div className='digitalVaultFollowUpDocument-followUpDocumentBasicData-dates-checkbox-row' style={{ display: 'flex', gap: '2rem', marginTop: "15px" }}>
                              <div className='date-block' style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: "10px" }}>
                                <Traslates>
                                  <DataPickerHLPure
                                    labelDataPicker={t('digitalVaultUploadView.start.date')}
                                    valueDate={dateStart}
                                    handleChangeDate={(e) => onChangeDatepicker(e)}
                                    formatPicker={formatCeleb}
                                    disabled={disableElements}
                                  />
                                </Traslates>
                                <label style={{ display: 'flex', alignItems: 'center', marginTop: '0.5rem' }}>
                                  <CheckBoxHLPure
                                    checkedState={confidential}
                                    onChangeHandler={(e) => handleChangeCheckConfidential(e)}
                                    disabled={disableElements}
                                  />
                                  <span style={{ marginLeft: '0.5rem' }}>{t('documentPanelBarBasicData.confidential')}</span>
                                </label>
                              </div>
                              <div className='date-block' style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: "10px" }}>
                                <Traslates>
                                  <Traslates>
                                    <DataPickerHLPure
                                      labelDataPicker={t('digitalVaultFollowUpDocument.date.due')}
                                      valueDate={dateEnd instanceof Date ? dateEnd : null}

                                      handleChangeDate={(e) => onChangeDatepickerDateEnd(e)}
                                      formatPicker={formatVen}
                                      disabled={disableElements}
                                      limitDate={limitDateDue instanceof Date ? limitDateDue : undefined}
                                    />
                                  </Traslates>
                                </Traslates>
                                <label style={{ display: 'flex', alignItems: 'center', marginTop: '0.5rem' }}>
                                  <CheckBoxHLPure
                                    checkedState={notify}
                                    onChangeHandler={(e) => handleChangeCheckNotify(e)}
                                    disabled={disableElements}
                                  />
                                  <span style={{ marginLeft: '0.5rem' }}>{t('digitalVaultUploadView.notification.expiration')}</span>
                                </label>
                              </div>
                            </div>

                            <div className='digitalVaultFollowUpDocument-followUpDocumentBasicData-container-tags'>
                              <InputHLPure
                                typeInput='text'
                                labelInput={t('digitalVaultFollowUpDocument.tags')}
                                valueInput={inputTag}
                                handleChangeInput={(e) => handleInputTag(e)}
                                tooltipShow={false}
                                informationIcon={false}
                                inputActive={true}
                                onBlur={onBlurInputTag}
                                onKeyDown={(e) => onEnterTag(e)}
                                disabled={disableElements}
                                characterLimit={50}
                              />
                              <div className='digitalVaultFollowUpDocument-followUpDocumentBasicData-tags'>
                                <ChipList
                                  selection='single'
                                  data={tags}
                                  chip={(props) => <Chip removable={true} {...props} onRemove={(e) => handleDeleteChipTag(e)} />}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </PanelBarGLPure>
                    </Grid>

                    {/* CLASIFICACION */}
                    <Grid style={{ marginTop: "15px" }}>
                      <PanelBarGLPure
                        expandedPanel={true}
                        titlePanel={t('digitalVaultUploadView.modal.clasification.title')}
                        className='documentPanelBarVariables'
                        id='documentPanelBarVariables'
                      >
                        <DropDownBtnHLPure
                          labelDropDown={t('digitalVaultUploadView.company')}
                          optionsDropDown={companies}
                          optionsValue={uploadData.companyId}
                          valueItem={'id'}
                          nameOption={'companyName'}
                          onDropDownChange={(e) => onDataChange(e, 'companyId')}
                          required
                        />
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <p className='inputHLPure-label'>{t('digitalVaultUploadView.category.subcategory')}</p>

                          <div style={{ display: 'flex', gap: '8px' }}>
                            {(!uploadData.categoryId || uploadData.categoryId === 0) ? (
                              <ButtonAddHLPure
                                nameBtn={t('digitalVaultUploadView.button.add.category')}
                                onClickBtn={openCategories}
                                iconAdd={true}
                              />
                            ) : (
                              <ButtonAddHLPure
                                nameBtn={t('digitalVaultUploadView.button.add.subcategory')}
                                onClickBtn={openSubcategories}
                                iconAdd={true}
                              />
                            )}
                          </div>
                        </div>
                        <div id="treeparent">
                          <div id="DigitalVault_treeview">
                            <TreeViewComponent
                              ref={(scope) => (treeRef = scope)}
                              fields={{
                                dataSource: categoriesData,
                                id: 'id',
                                parentID: 'parentId',
                                text: 'name',
                                hasChildren: 'hasChild',
                                iconCss: 'filterPath',
                              }}
                              cssClass="custom-treeview"
                              expandOn="Click"
                              allowMultiSelection={false}
                              nodeSelected={(e) => {
                                const liNode = e.node.closest('li')
                                if (treeRef && liNode && e.action === 'check') {
                                  treeRef.selectNode(liNode)
                                }

                                if (e.action === 'uncheck') {
                                  const selectedNodes = treeRef.element.querySelectorAll('.e-active')
                                  selectedNodes.forEach((node) => node.classList.remove('e-active'))

                                  const uncheckedNode = e.data[0]
                                  if (uncheckedNode && !uncheckedNode.hasChild) {
                                    handleUploadDataChange('categoryId', 0)
                                    handleUploadDataChange('pathBreadcrumb', [])
                                  }
                                  return
                                }
                                handleTreeNodeClick(e)
                              }}
                            />
                          </div>
                        </div>
                        <ComboBoxTemplatePure
                          title={uploadData.infoType === 1 ? t('digitalVaultUploadView.document.type') : t('digitalVaultUploadView.file.type')}
                          placeholder={uploadData.infoType === 1 ? t('digitalVaultUploadView.select.document.type') : t('digitalVaultUploadView.select.file.type')}
                          allowCustom
                          data={typeDocuments}
                          textField='name'
                          dataItemKey='id'
                          value={uploadData.typeDocument}
                          onChange={(e) => {
                            onDataChange(e, 'typeDocument')
                            if (!documentId) {
                              setCustomVariables(e.value?.variables || [])
                            }
                          }}
                          required
                          validityStyles={false}
                          errorCombobox={invalidFields.includes('typeDocument')}
                          errorMessag
                          infoType={uploadData.infoType}
                        />
                      </PanelBarGLPure>
                      {
                        showCategoryInputDialog &&
                        <DialogYesNoHLPure
                          btnCancel={true}
                          grid={true}
                          cancel={() => setShowCategoryInputDialog(false)}
                          handleCancel={() => setShowCategoryInputDialog(false)}
                          handleSubmit={handleCreateCategoryOrSubcategory}
                          saveBtn={getCategoryDialogText('saveBtn')}
                          textBtnCancel={getCategoryDialogText('cancelBtn')}
                          titleDialog={getCategoryDialogText('header')}
                        >
                          <InputHLPure
                            inputActive={true}
                            errorInput={categoryNameError}
                            errorInputText={getCategoryDialogText('errorInputText')}
                            labelInput={getCategoryDialogText('categoryInput')}
                            handleChangeInput={(e) => setCategoryName(e.target.value)}
                            required
                            typeInput={'text'}
                            valueInput={categoryName}
                            characterLimit={128}
                          />
                        </DialogYesNoHLPure>
                      }
                    </Grid>

                    {/* DATOS PERSONALIZADOS */}
                    <Grid style={{ marginTop: "15px" }} className='digitalVaultDocumentView upload-noPanelHeight'>
                      <>
                        <DocumentPanelBarVariables
                          variables={variablesList}
                          formatVariables={formatVariables || []}
                          createVariable={createOrUpdateVariableAdapter}
                          updateVariable={createOrUpdateVariableAdapter}
                          createOrUpdateVariable={createOrUpdateVariableAdapter}
                          deleteVariable={deleteVariableAdapter}
                          clearVariableValue={clearVariableValueAdapter}
                          documentData={documentDataForVariables}
                          entities={[]}
                          entitiesStatus={''}
                          isInDeleteFlow={uploadData && uploadData.typeDocument ? false : true}
                          skipDeleteConfirmation={true}
                          source='uploadView'
                        />
                      </>
                    </Grid>

                    {/* ENTIDADES */}
                    <Grid style={{ marginTop: "15px" }} className='digitalVaultDocumentView'>
                      <>
                        <PanelBarGLPure
                          expandedPanel={true}
                          titlePanel={t('digitalVaultUploadView.modal.entitie.title')}
                          className='documentPanelBarVariables'
                          id='documentPanelBarVariables'
                          actionComponent={
                            !entitiesExtracted && (
                              <ButtonAddHLPure
                                nameBtn={t('digitalVaultUploadView.modal.add.entitie.title')}
                                onClickBtn={openModalExtractEntities}
                                iconAdd={true}
                              />
                            )
                          }
                        >
                          <Grid item xs={12} className='digitalVaultUploadView-grid'>
                            <GridSelectionHLPure
                              styleGeneral={true}
                              styleGeneralClass={'documentPanelBarEntities-general-grid'}
                              pageable={false}
                              skip={0}
                              take={0}
                              dataGrid={[]}
                              noRecordsMessage={entitiesExtracted ? aiScheduledText : noAiText}
                              titleRow1={t('digitalVaultUploadView.grid.entity')}
                              cellColumnOne={CellColumnOne}
                              headerColumnOne={AllHeadersColumns}
                              widthColumnOne={widthColumnOne}
                              minResizableWidth1={'auto'}
                              columnTwo
                              titleRow2={t('digitalVaultUploadView.grid.usage')}
                              headerColumnTwo={AllHeadersColumns}
                              widthColumnTwo={widthColumnTwo}
                              fieldColumn2={'usage'}
                              minResizableWidth2={widthColumnFive}
                              onSelectedItem={setFileSelected}
                              setNameComponentUser={() => { }}
                              setShowDetails={() => { }}
                            />
                          </Grid>
                        </PanelBarGLPure>
                        {
                          showDialogSendDocToOcr && (
                            <DialogExtractEntities
                              documentsToOCR={documentsToOCR}
                              totalCredits={totalCredits}
                              onClickCheckBox={handleCheckBoxDoc}
                              closeModalEntities={closeModalSendToOcr}
                              saveEntities={saveExtractedEntities}
                              onClickSkipBtn={uploadDocumentFromDialog}
                            />
                          )
                        }
                      </>
                    </Grid>
                  </Grid>

                  {
                    showUploadBtn ?
                      (
                        <Grid item xs={12} md={6} onDragOver={handleDragOver} onDrop={handleDrop}>
                          <DialogSystemGLPure
                            showWarningRequesting={showAlert}
                            message={messageAlert}
                            toggleWarningRequesting={closeAlertDialog}
                          />
                          <Grid container spacing={3} alignContent='flex-start'>
                            <Grid item xs={12}>
                              <div className='digitalVaultUploadView-upload'>

                                <div className='digitalVaultUploadView-upload-section'>
                                  <div className='digitalVaultUploadView-instructions'>
                                    <InstructionsPure
                                      instructions={
                                        uploadData.infoType == 1
                                          ? [
                                            <>
                                              {t('digitalVaultUploadView.instructions.1.document')}{' '}
                                              <strong>{t('digitalVaultUploadView.instructions.1.document_strong')}</strong>{' '}
                                              {t('digitalVaultUploadView.instructions.1.document_2')}
                                            </>,
                                            <>
                                              {t('digitalVaultUploadView.instructions.2.document')}{' '}
                                              <strong>{t('digitalVaultUploadView.instructions.2.document_strong')}</strong>.
                                            </>,
                                            t('digitalVaultUploadView.instructions.3.document'),
                                          ]
                                          : uploadData.infoType == 2
                                            ? [
                                              <>
                                                {t('digitalVaultUploadView.instructions.1.file')}{' '}
                                                <strong>{t('digitalVaultUploadView.instructions.1.file_strong')}</strong>.
                                              </>,
                                              <>
                                                {t('digitalVaultUploadView.instructions.2.file')}{' '}
                                                <strong>{t('digitalVaultUploadView.instructions.2.file_strong')}</strong>.
                                              </>,
                                              t('digitalVaultUploadView.instructions.3.file'),
                                              t('digitalVaultUploadView.instructions.4.file'),
                                            ]
                                            : []
                                      }
                                    />
                                  </div>
                                  <div className='digitalVaultUploadView-upload-icon'>
                                    <label htmlFor='file-upload' className='digitalVaultUploadView-file-upload'>
                                      <input
                                        type='file'
                                        id='file-upload'
                                        required
                                        multiple={uploadData.infoType == 2}
                                        onClick={(e) => (e.target.value = null)}
                                        onChange={(e) => handleFile(e, showAlertDialog)}
                                      />
                                      <div className='upload-icon-box'>
                                        <img src={uploadFilesIcon} style={{ width: '60px', height: '60px' }} />
                                        <span style={invalidFields.includes('files') ? { color: 'red' } : null}>
                                          {t('digitalVaultUploadView.upload.file')}
                                          {uploadData.infoType == 2 && '(s)'}
                                        </span>
                                      </div>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </Grid>
                            {uploadData.uploadedFiles.length && fileShown.file
                              ?
                              <>
                                {
                                  fileType === 'pdf' &&
                                  <Grid item xs={12}>
                                    {pdf}
                                  </Grid>
                                }
                                {
                                  fileType === 'image' &&
                                  <Grid item xs={12}>
                                    <img
                                      src={`data:${fileShown.type};base64,${fileShown.fileBase64}`}
                                      className='digitalVaultUploadView-image'
                                    />
                                  </Grid>
                                }
                                {
                                  fileType === 'video' &&
                                  <Grid item xs={12}>
                                    <video
                                      src={`data:${fileShown.type};base64,${fileShown.fileBase64}`}
                                      controls
                                      disablePictureInPicture
                                      disableRemotePlayback
                                      className='digitalVaultUploadView-video'
                                    />
                                  </Grid>
                                }
                                {
                                  fileType === 'audio' &&
                                  <Grid item xs={12}>
                                    <audio
                                      src={`data:${fileShown.type};base64,${fileShown.fileBase64}`}
                                      controls
                                      style={{ width: '100%' }}
                                    />
                                  </Grid>
                                }
                              </>
                              : null
                            }
                          </Grid>
                        </Grid>
                      ) : (
                        <>
                          {
                            realFileType === 'pdf'
                            && <Grid item xs={12} md={6}>
                              <div className='followUpDocumentEntities-documentPDF' >
                                <div className='followUpDocumentEntities-documentPDF-container'>
                                  {pdfAWS ? pdfAWS : null}
                                </div>
                                <div className='followUpDocumentEntities-documentPDF-pdf-btn'>
                                  <DialogPdf blobUrl={blobAWS} />
                                </div>
                              </div>
                            </Grid>
                          }
                          {
                            realFileType === 'image' &&
                            <Grid item xs={12} md={6}>
                              <div className='followUpDocumentEntities-documentPDF' >
                                <div className='followUpDocumentEntities-documentPDF-container'>
                                  <img
                                    src={urlPdf}
                                    className='digitalVaultUploadView-image'
                                    alt='preview'
                                  />
                                </div>
                              </div>
                            </Grid>
                          }
                          {
                            realFileType === 'video' &&
                            <Grid item xs={12} md={6}>
                              <div className='followUpDocumentEntities-documentPDF' >
                                <div className='followUpDocumentEntities-documentPDF-container'>
                                  <video
                                    src={urlPdf}
                                    controls
                                    disablePictureInPicture
                                    disableRemotePlayback
                                    className='digitalVaultUploadView-video'
                                  />
                                </div>
                              </div>
                            </Grid>
                          }
                        </>
                      )
                  }

                  <Grid container item xs={12} justify='flex-end' className='digitalVaultUploadView-buttongroup'>
                    <ButtonHLPure
                      nameBtn={t('button.cancel')}
                      onClickBtn={(e) => setViewCancelDialog(true)}
                    />
                    {
                      showBtnCancel && (
                        <ButtonHLPure
                          nameBtn={t('button.reject')}
                          onClickBtn={() => setShowRejectDialog(true)}
                        />
                      )
                    }
                    <ButtonHLPure
                      nameBtn={t('button.save')}
                      primary
                      onClickBtn={() => {
                        const ocrMode = entitiesExtracted
                          ? 'Extraer entidades'
                          : ENV.PREFERENCE_PROCESS_DOCUMENT_BUTTON_NO_EXTRACT
                        if (documentId) {
                          handleUpdateDocument(true, ocrMode)
                        } else {
                          onSave(true, ocrMode)
                        }
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <PromotionalFooterPure />
                  </Grid>
                </Grid >
              </Container >
              {showCategoryWarningModal && (
                <DialogSystemGLPure
                  showWarningRequesting={showCategoryWarningModal}
                  message={(props?.categoryWarningMessage && props.categoryWarningMessage.trim()) ? props.categoryWarningMessage : subcategoryRequiredMsg}
                  toggleWarningRequesting={toggleCategoryWarningModal}
                  showButton
                  messageButton={t('button.close')}
                />
              )}
              {
                viewCancelDialog && <DialogYesNoHLPure
                  cancel={() => {
                    setViewCancelDialog(false)
                  }}
                  textBtnCancel={t('digitalVaultUploadView.modal.button.cancel')}
                  saveBtn={t('digitalVaultUploadView.modal.button.accept')}
                  titleDialog={t('digitalVaultUploadView.modal.title')}
                  handleSubmit={onCancel}
                >
                  <div className='digitalVaultUploadView-modal'>
                    <LabelModalPure label={t('digitalVaultUploadView.modal.question')} />
                    <LabelModalPure label={t('digitalVaultUploadView.modal.label')} />
                    <LabelModalPure label={t('digitalVaultUploadView.modal.reject')} />
                  </div>
                </DialogYesNoHLPure>
              }
              {
                showRejectDialog && (
                  <DialogYesNoHLPure
                    cancel={() => {
                      setShowRejectDialog(false)
                    }}
                    textBtnCancel={t('button.cancel')}
                    saveBtn={t('button.accept')}
                    titleDialog={t('digitalVaultUploadView.modal.reject.title')}
                    handleSubmit={(e) => {
                      setShowRejectDialog(false)
                      rejectUploadDocument(e)

                    }}
                  >
                    <div className='digitalVaultUploadView-modal-reject'>
                      <LabelModalPure label={t('digitalVaultUploadView.modal.reject.question')} />
                      <LabelModalPure label={t('digitalVaultUploadView.modal.reject.label')} />
                    </div>
                  </DialogYesNoHLPure>
                )
              }

              {
                showEntitiesSuccessModal && (
                  <DialogSystemGLPure
                    showLoadingRequesting={showLoadingRequesting}
                    toggleLoadingRequesting={toggleLoadingRequesting}

                    showCompletedRequesting={showCompletedRequesting}
                    toggleCompletedRequesting={toggleCompletedRequesting}
                    messageComplete={messageDialog}
                    showErrorRequesting={showErrorRequesting}
                    toggleErrorRequesting={toggleErrorRequesting}
                    messageError={messageError}
                  />
                )
              }
              <DialogSystemGLPure
                showLoadingRequesting={showLoadingRequesting}
                toggleLoadingRequesting={toggleLoadingRequesting}
                showCompletedRequesting={showCompletedRequesting}
                toggleCompletedRequesting={toggleCompletedRequesting}
                messageComplete={messageDialog}

                showErrorRequesting={showErrorRequesting}
                toggleErrorRequesting={toggleErrorRequesting}
                messageError={messageError} />
            </>
        }
      </div >
    </>
  )
}

export default DigitalVaultUploadView